export default {
	PRODUCT_CATEGORIES: 'Product categories',
};